import React, { Component, createRef, useRef } from "react";
import fontawesome from "@fortawesome/fontawesome";
import brands from "@fortawesome/fontawesome-free-brands";

import HTMLEllipsis from "react-lines-ellipsis/lib/html";
import LoadingBar from "react-top-loading-bar";
import "../include/css/bootstrap.min.css";
import "../include/css/style.css";
import "../include/css/dev.css";
import "./../include/css/product-gridview.css";
import { Link, navigate } from "gatsby";

import Footer from "../components/common/footer";

import { Accordion } from "react-bootstrap";
import _ from "lodash";
import Slider from "react-slick";
import { getEndingSoon } from "../actions/memberAction";
import DateFormat from "../components/common/dateFormat";
import { SEO } from "../components/seo";
import algoliasearch from "algoliasearch";
import Header from "../components/newDesign/header/header";
// import SEO from "../components/seo";

const category1 = `${process.env.GATSBY_IMAGE_URL}aviation-category-img.png`;
const category2 = `${process.env.GATSBY_IMAGE_URL}new-cat-img-2.jpg`;
const category3 = `${process.env.GATSBY_IMAGE_URL}new-cat-img-3.jpg`;
const category4 = `${process.env.GATSBY_IMAGE_URL}new-cat-img-4.jpg`;
const category5 = `${process.env.GATSBY_IMAGE_URL}new-cat-img-5.jpg`;
const category6 = `${process.env.GATSBY_IMAGE_URL}new-cat-img-6.jpg`;
const category7 = `${process.env.GATSBY_IMAGE_URL}new-cat-img-7.jpg`;
const category8 = `${process.env.GATSBY_IMAGE_URL}new-cat-img-8.jpg`;
const category9 = `${process.env.GATSBY_IMAGE_URL}new-cat-img-9.jpg`;
const category10 = `${process.env.GATSBY_IMAGE_URL}new-cat-img-10.jpg`;
const category11 = `${process.env.GATSBY_IMAGE_URL}new-cat-img-11.jpg`;
const category12 = `${process.env.GATSBY_IMAGE_URL}new-cat-img-12.jpg`;
const category13 = `${process.env.GATSBY_IMAGE_URL}new-cat-img-13.jpg`;
const category14 = `${process.env.GATSBY_IMAGE_URL}new-cat-img-14.jpg`;
const category15 = `${process.env.GATSBY_IMAGE_URL}new-cat-img-15.jpg`;

//new const
const hero3193 = `${process.env.GATSBY_IMAGE_URL}hero3193.jpg`;
const newtxtimg = `${process.env.GATSBY_IMAGE_URL}new-txt-img.jpg`;
fontawesome.library.add(brands);
const ref = createRef();
const productSlider = {
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 5,
  slidesToScroll: 1,
  arrows: false,
  responsive: [
    {
      breakpoint: 1800,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4,
        infinite: true,
        dots: false,
        arrows: false,
        centerMode: true,
        centerPadding: "60px",
      },
    },
    {
      breakpoint: 1400,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4,
        infinite: true,
        dots: false,
        arrows: false,
        centerMode: true,
        centerPadding: "60px",
      },
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: false,
        arrows: false,
        centerMode: true,
        centerPadding: "60px",
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        centerMode: true,
        centerPadding: "40px",
      },
    },
  ],
};

const client = algoliasearch(process.env.GATSBY_ALGOLIA_APP_ID, process.env.GATSBY_ALGOLIA_API_KEY);
const index = client.initIndex(process.env.GATSBY_ALGOLIA_LISTINGS_INDEX);

const CONDITION_OPTIONS = [
  { key: "Abandoned Freight", value: 1 },
  { key: "Antique & Collector", value: 2 },
  { key: "Beyond Economical Repair", value: 5 },
  { key: "Damaged", value: 8 },
  { key: "Damaged Transport Accident", value: 9 },
  { key: "Disposal", value: 10 },
  { key: "Disposal/Free", value: 11 },
  { key: "Insurance Claim Damaged", value: 15 },
  { key: "New", value: 17 },
  { key: "New Surplus", value: 18 },
  { key: "Repairable", value: 22 },
  { key: "Returns", value: 24 },
  { key: "Scrap", value: 25 },
  { key: "Tariff Abandoned", value: 27 },
  { key: "Unused", value: 31 },
  { key: "Used", value: 32 },
];

const AVIATION_CONDITION_OPTIONS = [
  { key: "As Is", value: 3 },
  { key: "As Removed", value: 4 },
  { key: "BER", value: 6 },
  { key: "Core", value: 7 },
  { key: "Factory New", value: 12 },
  { key: "Inspected", value: 13 },
  { key: "Inspected/Tested", value: 14 },
  { key: "Modified", value: 16 },
  { key: "Overhauled", value: 20 },
  { key: "Repaired", value: 23 },
  { key: "Serviceable", value: 26 },
  { key: "Tested", value: 28 },
  { key: "Unserviceable", value: 29 },
  { key: "Others", value: 19 },
];

const d = new Date();
class HomePage extends Component {
  getLocation = (a) => {
    switch (a.loc_sec) {
      case 0:
        if (a.geoRegion) {
          return a.c_des === "United States" ? "United States" : a.geoRegion;
        } else {
          if (a.st_des && a.st_des !== "International") {
            return a.st_des + ", " + a.c_des;
          } else {
            return a.c_des;
          }
        }
        break;
      case 1:
        if (a.st_des && a.st_des !== "International") {
          return a.st_des + ", " + a.c_des;
        } else {
          return a.c_des;
        }
        break;
      case 2:
        return a.city + ", " + a.st_des + ", " + a.c_des;
        break;
      case 3:
        return a.address_1 + ", " + a.city + ", " + a.st_des + ", " + a.zip + ", " + a.c_des;
        break;
    }
  };

  state = {
    collepsCat: false,
    endingSoon: [],
    queryData: "",
    showMobileFilter: false,
    loading: true,
    data: {},
    activeCat: "",
    subCat: {},
    data1: {},
    type: "sale",
    saleCount: 0,
    wantedCount: 0,
  };

  // Function to clear complete cache data
  clearCacheData = () => {
    caches.keys().then((names) => {
      names.forEach((name) => {
        caches.delete(name);
      });
    });
  };

  componentDidMount = async () => {
    let facets = ["*"];

    const records = await index.search("", {
      facets: facets,
      facetFilters: [["at_id:-6"]],
      hitsPerPage: 0,
    });

    const records1 = await index.search("", {
      facets: facets,
      facetFilters: [["at_id:6"]],
      hitsPerPage: 0,
    });

    this.setState({ data: records?.facets, saleCount: records?.nbHits });
    this.setState({ data1: records1?.facets, wantedCount: records1?.nbHits });

    this.clearCacheData();
    getEndingSoon((res) => {
      if (res && res.status == 200) {
        if (res.data.APP_VERSION !== process.env.GATSBY_APP_VERSION) {
          if (localStorage.getItem("isReloaded") !== res.data.APP_VERSION) {
            if (typeof window !== "undefined") {
              window.location.reload(true);
            }
          }
          // reload page and set in locastorage thet cloient is already reloaded for this bersion
          localStorage.setItem("isReloaded", res.data.APP_VERSION);
        }
        this.setState({ endingSoon: res.data.data, loading: false });
      }
    });
  };

  redirectToSearch = (event, url) => {
    event.preventDefault();
    navigate(url);
  };
  toggleMobileFilter = (e) => {
    if (e) e.preventDefault();
    this.setState({ showMobileFilter: !this.state.showMobileFilter });
  };
  setQueryData = (event) => {
    this.setState({ queryData: event });
  };

  render() {
    const {
      allCategoryListHome,
      allRegionsHome,
      allEndingSoon,
      allTopManufacturer,
      allHomePage,
      allCatagoryList,
      condition,
      conditionWanted,
    } = this.props.pageContext;
    let sliderRefs = createRef([]);

    const goNext = (id) => {
      sliderRefs.current[id]?.slickNext();
    };

    const goPrev = (id) => {
      sliderRefs.current[id]?.slickPrev();
    };

    return (
      <>
        <LoadingBar color="#47ad1d" ref={ref} />

        <Header />
        <div class="filter-outer-container">
          <div class="home-wrapper-container overflow-hidden" style={{ paddingTop: "0px" }}>
            <div class="container-fluid">
              <div class="row">
                <div class="col-lg-12 d-lg-flex">
                  <div class="hwc-box d-lg-flex flex-lg-wrap">
                    <div class="hwc-left d-none d-xl-block">
                      <div class="side-pannel">
                        <div class="nav nav-tabs nav-tabs1 custom-nav-tabs mob-full-width mb-3">
                          <a
                            href="javascript:void(0)"
                            class={`nav-link nav-link-1 ${this.state.type === "wanted" ? "has-place-bid" : "active"}`}
                            onClick={() => this.setState({ type: "sale" })}
                          >
                            <span>For Sale</span>
                          </a>

                          <a
                            href="javascript:void(0)"
                            class={`nav-link ${this.state.type === "sale" ? "has-place-bid" : "active"}`}
                            onClick={() => this.setState({ type: "wanted" })}
                          >
                            <span>Wanted</span>
                          </a>
                        </div>
                        {this.state.type === "sale" ? (
                          <Accordion
                            id="accorParent"
                            className="accordion add-custom-icons"
                            defaultActiveKey={["0", "1", "2", "3"]}
                            alwaysOpen={true}
                          >
                            {this.props.pageContext?.subCatData &&
                              Object.entries(this.props.pageContext?.subCatData)?.length > 0 && (
                                <Accordion.Item eventKey="0">
                                  <Accordion.Button className="acc-btn mb-10 " style={{ marginBottom: "5px" }}>
                                    Browse by Category
                                  </Accordion.Button>
                                  <Accordion.Body key={allCategoryListHome.edges.length}>
                                    <div className="accor-body">
                                      <Link
                                        className="mb-10 "
                                        style={{
                                          textDecoration: "underline",
                                          color: "#47ad1d",
                                          fontSize: "1rem",
                                          padding: "12px 0 ",
                                        }}
                                        to="/all-categories"
                                      >
                                        View All Categories
                                      </Link>
                                      {this.props.pageContext?.subCatData &&
                                        Object.entries(this.props.pageContext?.subCatData)
                                          ?.sort((a, b) => a[0].localeCompare(b[0]))
                                          ?.map((v, o) => {
                                            const id = v[0]?.split("_")[1];
                                            const name = v[0]?.split("_")[0];
                                            return name === "Pipe" ? (
                                              <Accordion id="accorTwo">
                                                <Accordion.Item
                                                  eventKey={v[0]}
                                                  onClick={() => this.setState({ activeCat: "Pipe" })}
                                                >
                                                  <Accordion.Button
                                                    // bsPrefix="home1-accor"
                                                    className="acc-btn mb-10 home1-accor"
                                                    onClick={(e) => this.redirectToSearch(e, `/pipe`)}
                                                  >
                                                    Pipe{" "}
                                                    {`${
                                                      this.state.data?.["categories.lvl0"]?.[`Pipe`]
                                                        ? `(${this.state.data?.["categories.lvl0"]?.[`Pipe`]})`
                                                        : ""
                                                    }`}
                                                  </Accordion.Button>
                                                </Accordion.Item>
                                              </Accordion>
                                            ) : name !== "Pipe" ? (
                                              <Accordion id="accorTwo">
                                                <Accordion.Item
                                                  eventKey={v[0]}
                                                  onClick={() => this.setState({ activeCat: v[0] })}
                                                >
                                                  <Accordion.Button
                                                    // bsPrefix="home1-accor"
                                                    className="acc-btn mb-10 home1-accor"
                                                    // onClick={(e) =>
                                                    //   v[0] === "Pipe"
                                                    //     ? this.redirectToSearch(e, `/pipe`)
                                                    //     : !v[1].length
                                                    //     ? this.redirectToSearch(e, `/listings/index.cfm/catid/${id}`)
                                                    //     : null
                                                    // }
                                                  >
                                                    {name}{" "}
                                                    {`${
                                                      this.state.data?.["categories.lvl0"]?.[`${v[0]}`]
                                                        ? `(${this.state.data?.["categories.lvl0"]?.[`${v[0]}`]})`
                                                        : ""
                                                    }`}
                                                  </Accordion.Button>
                                                  <Accordion.Body key={v[0]}>
                                                    {this.state.activeCat == v[0] ? (
                                                      <div className="inner-accor-body mb-10">
                                                        <ul>
                                                          <li>
                                                            <Link
                                                              style={{
                                                                textDecoration: "underline",
                                                                color: "#47ad1d",
                                                              }}
                                                              to={`/listings/index.cfm/catid/${id}`}
                                                            >
                                                              View All
                                                              {`${
                                                                this.state.data?.["categories.lvl0"]?.[`${v[0]}`]
                                                                  ? `(${
                                                                      this.state.data?.["categories.lvl0"]?.[`${v[0]}`]
                                                                    })`
                                                                  : ""
                                                              }`}
                                                            </Link>
                                                          </li>

                                                          {Object.entries(v[1])?.map((p) => {
                                                            const descp = p[0]?.split(">")?.[1]?.split("_")[0];
                                                            const subId = p[0]?.split(">")?.[1]?.split("_")[1];

                                                            return subId == 1280 ? (
                                                              <>
                                                                <li>
                                                                  <Link to={`/listings/index.cfm/catid/${subId}`}>
                                                                    Aircraft Parts Lots {p[1] ? `(${p[1]})` : ``}
                                                                  </Link>
                                                                </li>
                                                                <li>
                                                                  <Link to={`/aviation-parts/`}>
                                                                    {descp}{" "}
                                                                    {p[1]
                                                                      ? `(${process.env.GATSBY_AVIATION_COUNT})`
                                                                      : ``}
                                                                  </Link>
                                                                </li>
                                                              </>
                                                            ) : subId == 1776 ? (
                                                              <>
                                                                <li>
                                                                  <Link to={`/pipe/`}>
                                                                    Pipe and Tubular (Oil and Gas)
                                                                  </Link>
                                                                </li>
                                                              </>
                                                            ) : (
                                                              <li>
                                                                <Link to={`/listings/index.cfm/catid/${subId}`}>
                                                                  {descp} {p[1] ? `(${p[1]})` : ``}
                                                                </Link>
                                                              </li>
                                                            );
                                                          })}
                                                        </ul>
                                                      </div>
                                                    ) : (
                                                      ""
                                                    )}
                                                  </Accordion.Body>
                                                </Accordion.Item>
                                              </Accordion>
                                            ) : (
                                              ""
                                            );
                                          })}
                                    </div>
                                  </Accordion.Body>
                                </Accordion.Item>
                              )}

                            {allRegionsHome && allRegionsHome.edges && allRegionsHome.edges.length > 0 && (
                              <Accordion.Item eventKey="1">
                                <Accordion.Button
                                  className="acc-btn reg-home"
                                  style={{ marginTop: "5px", marginBottom: "5px" }}
                                >
                                  Browse by Region
                                </Accordion.Button>
                                <Accordion.Body key={allRegionsHome.length}>
                                  <div className="accor-body">
                                    <Link
                                      className="mb-10"
                                      style={{
                                        textDecoration: "underline",
                                        color: "#47ad1d",
                                        fontSize: "1rem",
                                        padding: "12px 0 ",
                                      }}
                                      to="/all-regions"
                                    >
                                      View All Regions
                                    </Link>
                                    {allRegionsHome.edges.map(
                                      (v) =>
                                        v.node.geoRegion === "North America" && (
                                          <Accordion id="accorTwo">
                                            <Accordion.Item eventKey={v.node.geoRegion}>
                                              <Accordion.Button
                                                className="acc-btn"
                                                onClick={(e) =>
                                                  !v.node.subRegion.length
                                                    ? this.redirectToSearch(
                                                        e,
                                                        `/listings/index.cfm/georegionid/${v.node.geoRegionID}`,
                                                      )
                                                    : null
                                                }
                                              >
                                                {"United States"}{" "}
                                                {this.state.data?.["regions.lvl0"]?.[`${v.node.geoRegion}`]
                                                  ? `(${this.state.data?.["regions.lvl0"]?.[`${v.node.geoRegion}`]})`
                                                  : ""}
                                              </Accordion.Button>
                                              <Accordion.Body key={v.node.description}>
                                                <div className="inner-accor-body mb-10">
                                                  <ul>
                                                    <li>
                                                      <a
                                                        style={{
                                                          textDecoration: "underline",
                                                          color: "#47ad1d",
                                                        }}
                                                        href={`/listings/index.cfm/georegionid/${v.node.geoRegionID}`}
                                                        onClick={(event) =>
                                                          this.redirectToSearch(
                                                            event,
                                                            `/listings/index.cfm/georegionid/${v.node.geoRegionID}`,
                                                          )
                                                        }
                                                      >
                                                        View All
                                                        {this.state.data?.["regions.lvl0"]?.[`${v.node.geoRegion}`]
                                                          ? `(${
                                                              this.state.data?.["regions.lvl0"]?.[`${v.node.geoRegion}`]
                                                            })`
                                                          : ""}
                                                      </a>
                                                    </li>
                                                    {v.node.subRegion.map((v1) => (
                                                      <li>
                                                        <a
                                                          href={`/listings/index.cfm/regid/${v1.region_id}`}
                                                          onClick={(event) =>
                                                            this.redirectToSearch(
                                                              event,
                                                              `/listings/index.cfm/regid/${v1.region_id}`,
                                                            )
                                                          }
                                                        >
                                                          {v1.description}{" "}
                                                          {this.state.data?.["regions.lvl1"]?.[
                                                            `United States > ${v1.description}`
                                                          ]
                                                            ? `(${
                                                                this.state.data?.["regions.lvl1"]?.[
                                                                  `United States > ${v1.description}`
                                                                ]
                                                              })`
                                                            : ``}
                                                        </a>
                                                      </li>
                                                    ))}
                                                  </ul>
                                                </div>
                                              </Accordion.Body>
                                            </Accordion.Item>
                                          </Accordion>
                                        ),
                                    )}

                                    {allRegionsHome.edges
                                      .sort((a, b) => {
                                        var textA = a.node.geoRegion.toUpperCase();
                                        var textB = b.node.geoRegion.toUpperCase();
                                        return textA < textB ? -1 : textA > textB ? 1 : 0;
                                      })
                                      .map((v) =>
                                        v.node.subRegion &&
                                        v.node.subRegion.length > 0 &&
                                        v.node.geoRegion !== "North America" ? (
                                          <Accordion id="accorTwo">
                                            <Accordion.Item eventKey={v.node.geoRegion}>
                                              <Accordion.Button
                                                className="acc-btn"
                                                onClick={(e) =>
                                                  !v.node.subRegion.length
                                                    ? this.redirectToSearch(
                                                        e,
                                                        `/listings/index.cfm/georegionid/${v.node.geoRegionID}`,
                                                      )
                                                    : null
                                                }
                                              >
                                                {v.node.geoRegion}{" "}
                                                {this.state.data?.["regions.lvl0"]?.[`${v.node.geoRegion}`]
                                                  ? `(${this.state.data?.["regions.lvl0"]?.[`${v.node.geoRegion}`]})`
                                                  : ``}
                                              </Accordion.Button>
                                              <Accordion.Body key={v.node.description}>
                                                <div className="inner-accor-body mb-10">
                                                  <ul>
                                                    <li>
                                                      <a
                                                        style={{
                                                          textDecoration: "underline",
                                                          color: "#47ad1d",
                                                        }}
                                                        href={`/listings/index.cfm/georegionid/${v.node.geoRegionID}`}
                                                        onClick={(event) =>
                                                          this.redirectToSearch(
                                                            event,
                                                            `/listings/index.cfm/georegionid/${v.node.geoRegionID}`,
                                                          )
                                                        }
                                                      >
                                                        View All
                                                        {this.state.data?.["regions.lvl0"]?.[`${v.node.geoRegion}`]
                                                          ? `(${
                                                              this.state.data?.["regions.lvl0"]?.[`${v.node.geoRegion}`]
                                                            })`
                                                          : ``}
                                                      </a>
                                                    </li>
                                                    {v.node.subRegion.map((v1) => (
                                                      <li>
                                                        <a
                                                          href={`/listings/index.cfm/regid/${v1.region_id}`}
                                                          onClick={(event) =>
                                                            this.redirectToSearch(
                                                              event,
                                                              `/listings/index.cfm/regid/${v1.region_id}`,
                                                            )
                                                          }
                                                        >
                                                          {v1.description}{" "}
                                                          {this.state.data?.["regions.lvl1"]?.[`${v1.description}`]
                                                            ? `(${
                                                                this.state.data?.["regions.lvl1"]?.[`${v1.description}`]
                                                              })`
                                                            : ``}
                                                        </a>
                                                      </li>
                                                    ))}
                                                  </ul>
                                                </div>
                                              </Accordion.Body>
                                            </Accordion.Item>
                                          </Accordion>
                                        ) : (
                                          v.node.geoRegion !== "North America" && (
                                            <p
                                              class="para-item"
                                              onClick={(e) =>
                                                !v.node.subRegion.length
                                                  ? this.redirectToSearch(
                                                      e,
                                                      `/listings/index.cfm/?geoRegionID${v.node.geoRegionID}`,
                                                    )
                                                  : null
                                              }
                                            >
                                              {v.node.geoRegion}{" "}
                                              {this.state.data?.["regions.lvl1"]?.[`${v.node.geoRegion}`]
                                                ? `(${this.state.data?.["regions.lvl1"]?.[`${v.node.geoRegion}`]})`
                                                : ``}
                                            </p>
                                          )
                                        ),
                                      )}
                                  </div>
                                </Accordion.Body>
                              </Accordion.Item>
                            )}

                            {allTopManufacturer && allTopManufacturer.edges && allTopManufacturer.edges.length > 0 && (
                              <Accordion.Item eventKey="2">
                                <Accordion.Button className="acc-btn reg-home" style={{ marginTop: "5px" }}>
                                  Browse by Manufacturer
                                </Accordion.Button>
                                <Accordion.Body key={allTopManufacturer.length}>
                                  <div className="accor-body">
                                    <Link
                                      className="mb-10"
                                      style={{
                                        textDecoration: "underline",
                                        color: "#47ad1d",
                                        fontSize: "1rem",
                                        padding: "12px 0 ",
                                      }}
                                      to="/all-manufacturers"
                                    >
                                      View All Manufacturers
                                    </Link>
                                    {allTopManufacturer.edges
                                      .sort((a, b) => {
                                        const descA = a.node.description.toUpperCase(); // Ignoring case sensitivity
                                        const descB = b.node.description.toUpperCase();

                                        if (descA < descB) {
                                          return -1; // Sort a before b
                                        }
                                        if (descA > descB) {
                                          return 1; // Sort b before a
                                        }
                                        return 0;
                                      })
                                      ?.map((v) => (
                                        <p
                                          class="para-item mfr-home"
                                          onClick={(e) =>
                                            this.redirectToSearch(e, `/listings/index.cfm/mfr/${v.node.mfrid}`)
                                          }
                                        >
                                          {v.node.description}{" "}
                                          {this.state.data?.["make"]?.[`${v.node.description}`]
                                            ? `(${this.state.data?.["make"]?.[`${v.node.description}`]})`
                                            : ""}
                                        </p>
                                      ))}
                                  </div>
                                </Accordion.Body>
                              </Accordion.Item>
                            )}
                            {condition && condition?.length > 0 && (
                              <Accordion.Item eventKey="3">
                                <Accordion.Button className="acc-btn reg-home" style={{ marginTop: "5px" }}>
                                  Browse by Condition
                                </Accordion.Button>
                                <Accordion.Body key={condition.length}>
                                  <div className="accor-body">
                                    {condition
                                      ?.sort((a, b) => a[0].localeCompare(b[0]))
                                      ?.map(([nameObj, numberObj]) => {
                                        const match = CONDITION_OPTIONS.find((opt) => opt.key === nameObj);
                                        if (!match) return null;
                                        return (
                                          <p
                                            key={nameObj}
                                            className="para-item mfr-home"
                                            onClick={() => navigate(`/listings/index.cfm/condition/${match.value}`)}
                                          >
                                            {nameObj} {numberObj ? `(${numberObj})` : ""}
                                          </p>
                                        );
                                      })
                                      .filter(Boolean)}
                                    <div
                                      style={{ border: "1px solid #efefef", marginTop: "10px", marginBottom: "10px" }}
                                    ></div>
                                    {condition
                                      ?.sort((a, b) => a[0].localeCompare(b[0]))
                                      ?.map(([nameObj, numberObj]) => {
                                        const match = AVIATION_CONDITION_OPTIONS.find((opt) => opt.key === nameObj);
                                        if (!match) return null;
                                        return (
                                          <p
                                            key={nameObj}
                                            className="para-item mfr-home"
                                            onClick={() => navigate(`/listings/index.cfm/condition/${match.value}`)}
                                          >
                                            {nameObj + " - Aviation"} {numberObj ? `(${numberObj})` : ""}
                                          </p>
                                        );
                                      })
                                      .filter(Boolean)}
                                  </div>
                                </Accordion.Body>
                              </Accordion.Item>
                            )}
                          </Accordion>
                        ) : (
                          <Accordion
                            id="accorParent"
                            className="accordion add-custom-icons"
                            defaultActiveKey={["0", "1", "2", "3"]}
                            alwaysOpen={true}
                          >
                            {this.props.pageContext?.subCatData1 &&
                              Object.entries(this.props.pageContext?.subCatData1)?.length > 0 && (
                                <Accordion.Item eventKey="0">
                                  <Accordion.Button className="acc-btn mb-10 " style={{ marginBottom: "5px" }}>
                                    Browse by Category
                                  </Accordion.Button>
                                  <Accordion.Body key={allCategoryListHome.edges.length}>
                                    <div className="accor-body">
                                      <Link
                                        className="mb-10 "
                                        style={{
                                          textDecoration: "underline",
                                          color: "#47ad1d",
                                          fontSize: "1rem",
                                          padding: "12px 0 ",
                                        }}
                                        to="/all-categories"
                                      >
                                        View All Categories
                                      </Link>
                                      {this.props.pageContext?.subCatData1 &&
                                        Object.entries(this.props.pageContext?.subCatData1)
                                          ?.sort((a, b) => a[0].localeCompare(b[0]))
                                          ?.map((v, o) => {
                                            const id = v[0]?.split("_")[1];
                                            const name = v[0]?.split("_")[0];
                                            return name === "Pipe" &&
                                              this.state.data1?.["categories.lvl0"]?.[`Pipe`] ? (
                                              <Accordion id="accorTwo">
                                                <Accordion.Item
                                                  eventKey={v[0]}
                                                  onClick={() => this.setState({ activeCat: "Pipe" })}
                                                >
                                                  <Accordion.Button
                                                    // bsPrefix="home1-accor"
                                                    className="acc-btn mb-10 home1-accor"
                                                    onClick={(e) => this.redirectToSearch(e, `/pipe`)}
                                                  >
                                                    Pipe{" "}
                                                    {`${
                                                      this.state.data1?.["categories.lvl0"]?.[`Pipe`]
                                                        ? `(${this.state.data1?.["categories.lvl0"]?.[`Pipe`]})`
                                                        : ""
                                                    }`}
                                                  </Accordion.Button>
                                                </Accordion.Item>
                                              </Accordion>
                                            ) : name !== "Pipe" &&
                                              this.state.data1?.["categories.lvl0"]?.[`${v[0]}`] ? (
                                              <Accordion id="accorTwo">
                                                <Accordion.Item
                                                  eventKey={v[0]}
                                                  onClick={() => this.setState({ activeCat: v[0] })}
                                                >
                                                  <Accordion.Button
                                                    // bsPrefix="home1-accor"
                                                    className="acc-btn mb-10 home1-accor"
                                                    // onClick={(e) =>
                                                    //   v[0] === "Pipe"
                                                    //     ? this.redirectToSearch(e, `/pipe`)
                                                    //     : !v[1].length
                                                    //     ? this.redirectToSearch(e, `/listings/index.cfm/catid/${id}`)
                                                    //     : null
                                                    // }
                                                  >
                                                    {name}{" "}
                                                    {`${
                                                      this.state.data1?.["categories.lvl0"]?.[`${v[0]}`]
                                                        ? `(${this.state.data1?.["categories.lvl0"]?.[`${v[0]}`]})`
                                                        : ""
                                                    }`}
                                                  </Accordion.Button>
                                                  <Accordion.Body key={v[0]}>
                                                    {this.state.activeCat == v[0] ? (
                                                      <div className="inner-accor-body mb-10">
                                                        <ul>
                                                          <li>
                                                            <Link
                                                              style={{
                                                                textDecoration: "underline",
                                                                color: "#47ad1d",
                                                              }}
                                                              to={`/listings/index.cfm/catid/${id}/?listing=wanted`}
                                                            >
                                                              View All
                                                              {`${
                                                                this.state.data1?.["categories.lvl0"]?.[`${v[0]}`]
                                                                  ? `(${
                                                                      this.state.data1?.["categories.lvl0"]?.[`${v[0]}`]
                                                                    })`
                                                                  : ""
                                                              }`}
                                                            </Link>
                                                          </li>

                                                          {Object.entries(v[1])?.map((p) => {
                                                            const descp = p[0]?.split(">")?.[1]?.split("_")[0];
                                                            const subId = p[0]?.split(">")?.[1]?.split("_")[1];

                                                            return subId == 1280 && p[1] ? (
                                                              <>
                                                                <li>
                                                                  <Link
                                                                    to={`/listings/index.cfm/catid/${subId}/?listing=wanted`}
                                                                  >
                                                                    Aircraft Parts Lots {p[1] ? `(${p[1]})` : ``}
                                                                  </Link>
                                                                </li>
                                                              </>
                                                            ) : subId == 1776 && p[1] ? (
                                                              <>
                                                                <li>
                                                                  <Link to={`/pipe/`}>
                                                                    Pipe and Tubular (Oil and Gas){" "}
                                                                    {p[1] ? `(${p[1]})` : ``}
                                                                  </Link>
                                                                </li>
                                                              </>
                                                            ) : (
                                                              p[1] && (
                                                                <li>
                                                                  <Link
                                                                    to={`/listings/index.cfm/catid/${subId}/?listing=wanted`}
                                                                  >
                                                                    {descp} {p[1] ? `(${p[1]})` : ``}
                                                                  </Link>
                                                                </li>
                                                              )
                                                            );
                                                          })}
                                                        </ul>
                                                      </div>
                                                    ) : (
                                                      ""
                                                    )}
                                                  </Accordion.Body>
                                                </Accordion.Item>
                                              </Accordion>
                                            ) : (
                                              ""
                                            );
                                          })}
                                    </div>
                                  </Accordion.Body>
                                </Accordion.Item>
                              )}

                            {allRegionsHome && allRegionsHome.edges && allRegionsHome.edges.length > 0 && (
                              <Accordion.Item eventKey="1">
                                <Accordion.Button
                                  className="acc-btn reg-home"
                                  style={{ marginTop: "5px", marginBottom: "5px" }}
                                >
                                  Browse by Region
                                </Accordion.Button>
                                <Accordion.Body key={allRegionsHome.length}>
                                  <div className="accor-body">
                                    <Link
                                      className="mb-10"
                                      style={{
                                        textDecoration: "underline",
                                        color: "#47ad1d",
                                        fontSize: "1rem",
                                        padding: "12px 0 ",
                                      }}
                                      to="/all-regions"
                                    >
                                      View All Regions
                                    </Link>
                                    {allRegionsHome.edges.map(
                                      (v) =>
                                        v.node.geoRegion === "North America" && (
                                          <Accordion id="accorTwo">
                                            <Accordion.Item eventKey={v.node.geoRegion}>
                                              <Accordion.Button
                                                className="acc-btn"
                                                onClick={(e) =>
                                                  !v.node.subRegion.length
                                                    ? this.redirectToSearch(
                                                        e,
                                                        `/listings/index.cfm/georegionid/${v.node.geoRegionID}/?listing=wanted`,
                                                      )
                                                    : null
                                                }
                                              >
                                                {"United States"}{" "}
                                                {this.state.data1?.["regions.lvl0"]?.[`${v.node.geoRegion}`]
                                                  ? `(${this.state.data1?.["regions.lvl0"]?.[`${v.node.geoRegion}`]})`
                                                  : ""}
                                              </Accordion.Button>
                                              <Accordion.Body key={v.node.description}>
                                                <div className="inner-accor-body mb-10">
                                                  <ul>
                                                    <li>
                                                      <a
                                                        style={{
                                                          textDecoration: "underline",
                                                          color: "#47ad1d",
                                                        }}
                                                        href={`/listings/index.cfm/georegionid/${v.node.geoRegionID}/?listing=wanted`}
                                                        onClick={(event) =>
                                                          this.redirectToSearch(
                                                            event,
                                                            `/listings/index.cfm/georegionid/${v.node.geoRegionID}/?listing=wanted`,
                                                          )
                                                        }
                                                      >
                                                        View All
                                                        {this.state.data1?.["regions.lvl0"]?.[`${v.node.geoRegion}`]
                                                          ? `(${
                                                              this.state.data1?.["regions.lvl0"]?.[
                                                                `${v.node.geoRegion}`
                                                              ]
                                                            })`
                                                          : ""}
                                                      </a>
                                                    </li>
                                                    {v.node.subRegion.map((v1) =>
                                                      this.state.data1?.["regions.lvl1"]?.[
                                                        `United States > ${v1.description}`
                                                      ] ? (
                                                        <li>
                                                          <a
                                                            href={`/listings/index.cfm/regid/${v1.region_id}/?listing=wanted`}
                                                            onClick={(event) =>
                                                              this.redirectToSearch(
                                                                event,
                                                                `/listings/index.cfm/regid/${v1.region_id}/?listing=wanted`,
                                                              )
                                                            }
                                                          >
                                                            {v1.description}{" "}
                                                            {this.state.data1?.["regions.lvl1"]?.[
                                                              `United States > ${v1.description}`
                                                            ]
                                                              ? `(${
                                                                  this.state.data1?.["regions.lvl1"]?.[
                                                                    `United States > ${v1.description}`
                                                                  ]
                                                                })`
                                                              : ``}
                                                          </a>
                                                        </li>
                                                      ) : (
                                                        ""
                                                      ),
                                                    )}
                                                  </ul>
                                                </div>
                                              </Accordion.Body>
                                            </Accordion.Item>
                                          </Accordion>
                                        ),
                                    )}

                                    {allRegionsHome.edges
                                      .sort((a, b) => {
                                        var textA = a.node.geoRegion.toUpperCase();
                                        var textB = b.node.geoRegion.toUpperCase();
                                        return textA < textB ? -1 : textA > textB ? 1 : 0;
                                      })
                                      .map((v) =>
                                        v.node.subRegion &&
                                        v.node.subRegion.length > 0 &&
                                        v.node.geoRegion !== "North America" &&
                                        this.state.data?.["regions.lvl0"]?.[`${v.node.geoRegion}`] ? (
                                          <Accordion id="accorTwo">
                                            <Accordion.Item eventKey={v.node.geoRegion}>
                                              <Accordion.Button
                                                className="acc-btn"
                                                onClick={(e) =>
                                                  !v.node.subRegion.length
                                                    ? this.redirectToSearch(
                                                        e,
                                                        `/listings/index.cfm/georegionid/${v.node.geoRegionID}/?listing=wanted`,
                                                      )
                                                    : null
                                                }
                                              >
                                                {v.node.geoRegion}{" "}
                                                {this.state.data?.["regions.lvl0"]?.[`${v.node.geoRegion}`]
                                                  ? `(${this.state.data?.["regions.lvl0"]?.[`${v.node.geoRegion}`]})`
                                                  : ``}
                                              </Accordion.Button>
                                              <Accordion.Body key={v.node.description}>
                                                <div className="inner-accor-body mb-10">
                                                  <ul>
                                                    <li>
                                                      <a
                                                        style={{
                                                          textDecoration: "underline",
                                                          color: "#47ad1d",
                                                        }}
                                                        href={`/listings/index.cfm/georegionid/${v.node.geoRegionID}/?listing=wanted`}
                                                        onClick={(event) =>
                                                          this.redirectToSearch(
                                                            event,
                                                            `/listings/index.cfm/georegionid/${v.node.geoRegionID}/?listing=wanted`,
                                                          )
                                                        }
                                                      >
                                                        View All
                                                        {this.state.data1?.["regions.lvl0"]?.[`${v.node.geoRegion}`]
                                                          ? `(${
                                                              this.state.data1?.["regions.lvl0"]?.[
                                                                `${v.node.geoRegion}`
                                                              ]
                                                            })`
                                                          : ``}
                                                      </a>
                                                    </li>
                                                    {v.node.subRegion.map((v1) =>
                                                      this.state.data1?.["regions.lvl1"]?.[`${v1.description}`] ? (
                                                        <li>
                                                          <a
                                                            href={`/listings/index.cfm/regid/${v1.region_id}/?listing=wanted`}
                                                            onClick={(event) =>
                                                              this.redirectToSearch(
                                                                event,
                                                                `/listings/index.cfm/regid/${v1.region_id}/?listing=wanted`,
                                                              )
                                                            }
                                                          >
                                                            {v1.description}{" "}
                                                            {this.state.data1?.["regions.lvl1"]?.[`${v1.description}`]
                                                              ? `(${
                                                                  this.state.data1?.["regions.lvl1"]?.[
                                                                    `${v1.description}`
                                                                  ]
                                                                })`
                                                              : ``}
                                                          </a>
                                                        </li>
                                                      ) : (
                                                        ""
                                                      ),
                                                    )}
                                                  </ul>
                                                </div>
                                              </Accordion.Body>
                                            </Accordion.Item>
                                          </Accordion>
                                        ) : (
                                          v.node.geoRegion !== "North America" &&
                                          this.state.data1?.["regions.lvl1"]?.[`${v.node.geoRegion}`] && (
                                            <p
                                              class="para-item"
                                              onClick={(e) =>
                                                !v.node.subRegion.length
                                                  ? this.redirectToSearch(
                                                      e,
                                                      `/listings/index.cfm/?geoRegionID${v.node.geoRegionID}/?listing=wanted`,
                                                    )
                                                  : null
                                              }
                                            >
                                              {v.node.geoRegion}{" "}
                                              {this.state.data1?.["regions.lvl1"]?.[`${v.node.geoRegion}`]
                                                ? `(${this.state.data1?.["regions.lvl1"]?.[`${v.node.geoRegion}`]})`
                                                : ``}
                                            </p>
                                          )
                                        ),
                                      )}
                                  </div>
                                </Accordion.Body>
                              </Accordion.Item>
                            )}

                            {allTopManufacturer && allTopManufacturer.edges && allTopManufacturer.edges.length > 0 && (
                              <Accordion.Item eventKey="2">
                                <Accordion.Button className="acc-btn reg-home" style={{ marginTop: "5px" }}>
                                  Browse by Manufacturer
                                </Accordion.Button>
                                <Accordion.Body key={allTopManufacturer.length}>
                                  <div className="accor-body">
                                    <Link
                                      className="mb-10"
                                      style={{
                                        textDecoration: "underline",
                                        color: "#47ad1d",
                                        fontSize: "1rem",
                                        padding: "12px 0 ",
                                      }}
                                      to="/all-manufacturers"
                                    >
                                      View All Manufacturers
                                    </Link>
                                    {allTopManufacturer.edges
                                      .sort((a, b) => {
                                        const descA = a.node.description.toUpperCase(); // Ignoring case sensitivity
                                        const descB = b.node.description.toUpperCase();

                                        if (descA < descB) {
                                          return -1; // Sort a before b
                                        }
                                        if (descA > descB) {
                                          return 1; // Sort b before a
                                        }
                                        return 0;
                                      })
                                      ?.map((v) =>
                                        this.state.data1?.["make"]?.[`${v.node.description}`] ? (
                                          <p
                                            class="para-item mfr-home"
                                            onClick={(e) =>
                                              this.redirectToSearch(
                                                e,
                                                `/listings/index.cfm/mfr/${v.node.mfrid}/?listing=wanted`,
                                              )
                                            }
                                          >
                                            {v.node.description}{" "}
                                            {this.state.data1?.["make"]?.[`${v.node.description}`]
                                              ? `(${this.state.data1?.["make"]?.[`${v.node.description}`]})`
                                              : ""}
                                          </p>
                                        ) : (
                                          ""
                                        ),
                                      )}
                                  </div>
                                </Accordion.Body>
                              </Accordion.Item>
                            )}

                            {conditionWanted && conditionWanted?.length > 0 && (
                              <Accordion.Item eventKey="3">
                                <Accordion.Button className="acc-btn reg-home" style={{ marginTop: "5px" }}>
                                  Browse by Condition
                                </Accordion.Button>
                                <Accordion.Body key={condition.length}>
                                  <div className="accor-body">
                                    {conditionWanted
                                      ?.map(([nameObj, numberObj]) => {
                                        const match = CONDITION_OPTIONS.find((opt) => opt.key === nameObj);
                                        if (!match) return null;
                                        return (
                                          <p
                                            key={nameObj}
                                            className="para-item mfr-home"
                                            onClick={() =>
                                              navigate(`/listings/index.cfm/condition/${match.value}/?listing=wanted`)
                                            }
                                          >
                                            {nameObj} {numberObj ? `(${numberObj})` : ""}
                                          </p>
                                        );
                                      })
                                      .filter(Boolean)}
                                    <div
                                      style={{ border: "1px solid #efefef", marginTop: "10px", marginBottom: "10px" }}
                                    ></div>
                                    {conditionWanted
                                      ?.sort((a, b) => a[0].localeCompare(b[0]))
                                      ?.map(([nameObj, numberObj]) => {
                                        const match = AVIATION_CONDITION_OPTIONS.find((opt) => opt.key === nameObj);
                                        if (!match) return null;
                                        return (
                                          <p
                                            key={nameObj}
                                            className="para-item mfr-home"
                                            onClick={() => navigate(`/listings/index.cfm/condition/${match.value}`)}
                                          >
                                            {nameObj + " - Aviation"} {numberObj ? `(${numberObj})` : ""}
                                          </p>
                                        );
                                      })
                                      .filter(Boolean)}
                                  </div>
                                </Accordion.Body>
                              </Accordion.Item>
                            )}
                          </Accordion>
                        )}
                      </div>
                    </div>
                  </div>
                  <div class="hwc-right">
                    <div class="widget-hero-container d-flex flex-wrap">
                      <div class="whc-left">
                        <div class="whc-hero-content add-whc-shape position-relative w-100 h-100">
                          <div
                            class="whc-hero-bg"
                            style={{
                              backgroundImage: `url('${hero3193}')`,
                            }}
                          ></div>
                          <div class="whc-hero-text h-100  d-flex flex-column left-banner">
                            {/* <h4>Bids closing in the next week</h4> */}
                            <h1 className="new-banner-text home-heading">
                              Browse our global marketplace of surplus inventory and asset recovery sales
                            </h1>
                            <div class="whc-hero-btn mt-auto">
                              <Link to="/members/register" class="btn btn-black">
                                Get Started
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="whc-right">
                        <div class="whc-text-row position-relative w-100 h-100">
                          <div
                            class="whc-text-bg"
                            style={{
                              backgroundImage: `url('${newtxtimg}')`,
                            }}
                          ></div>
                          <div class="whc-text h-100  d-flex flex-column text-center ">
                            <h2 style={{ fontSize: "20px" }} className="home-sub-heading">
                              Sustainability Solutions
                            </h2>
                            <p>
                              Salvex creates carbon offsets by <br /> repurposing distressed commercial assets.
                              <br /> Learn how you can go carbon neutral.
                            </p>
                            <div class="whc-txt-btn mt-auto">
                              <a
                                href="https://www.aboutsalvex.com/environmental/"
                                class="btn btn-default"
                                target="_blank"
                              >
                                Learn More
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="widget-box">
                      <div class="widget-header d-flex flex-wrap align-items-center">
                        <h4>Categories</h4>
                      </div>
                      <div class="widget-body">
                        <ul class="new-categories-list d-flex flex-wrap">
                          <li class="new-categories-item">
                            <div
                              class="new-categories-box"
                              onClick={(event) => this.redirectToSearch(event, "/listings/index.cfm/catid/1176")}
                            >
                              <div class="new-categories-image">
                                <img src={category1} loading="lazy" alt="Aviation" />
                              </div>
                              <p>Aviation</p>
                            </div>
                          </li>
                          <li class="new-categories-item">
                            <div
                              class="new-categories-box"
                              onClick={(event) => this.redirectToSearch(event, "/listings/index.cfm/catid/1003")}
                            >
                              <div class="new-categories-image">
                                <img src={category2} loading="lazy" alt="Building Materials" />
                              </div>
                              <p>
                                Building <br /> Materials
                              </p>
                            </div>
                          </li>
                          <li class="new-categories-item">
                            <div
                              class="new-categories-box"
                              onClick={(event) => this.redirectToSearch(event, "/listings/index.cfm/catid/1004")}
                            >
                              <div class="new-categories-image">
                                <img
                                  src={category3}
                                  loading="lazy"
                                  alt="Chemicals, Minerals, Fertilizers and Plastics"
                                />
                              </div>
                              <p>Chemicals, Minerals, Fertilizers and Plastics</p>
                            </div>
                          </li>
                          <li class="new-categories-item">
                            <div class="new-categories-box">
                              <div
                                class="new-categories-image"
                                onClick={(event) => this.redirectToSearch(event, "/listings/index.cfm/catid/1005")}
                              >
                                <img src={category4} loading="lazy" alt="Commercial Equipment" />
                              </div>
                              <p>
                                Commercial <br /> Equipment
                              </p>
                            </div>
                          </li>
                          <li class="new-categories-item">
                            <div class="new-categories-box">
                              <div
                                class="new-categories-image"
                                onClick={(event) => this.redirectToSearch(event, "/listings/index.cfm/catid/1006")}
                              >
                                <img src={category5} loading="lazy" alt="Computers Peripherals" />
                              </div>
                              <p>
                                Computers <br /> &amp; Peripherals
                              </p>
                            </div>
                          </li>
                          <li class="new-categories-item">
                            <div
                              class="new-categories-box"
                              onClick={(event) => this.redirectToSearch(event, "/listings/index.cfm/catid/1011")}
                            >
                              <div class="new-categories-image">
                                <img src={category6} loading="lazy" alt="Consumer Goods" />
                              </div>
                              <p>
                                Consumer <br /> Goods
                              </p>
                            </div>
                          </li>
                          <li class="new-categories-item">
                            <div
                              class="new-categories-box"
                              onClick={(event) => this.redirectToSearch(event, "/listings/index.cfm/catid/1294")}
                            >
                              <div class="new-categories-image">
                                <img src={category7} loading="lazy" alt=" Energy Oil, Gas and Utilities" />
                              </div>
                              <p>
                                Energy Oil, Gas <br /> and Utilities
                              </p>
                            </div>
                          </li>
                          <li class="new-categories-item">
                            <div
                              class="new-categories-box"
                              onClick={(event) => this.redirectToSearch(event, "/listings/index.cfm/catid/1046")}
                            >
                              <div class="new-categories-image">
                                <img src={category8} loading="lazy" alt="Heavy Equipment" />
                              </div>
                              <p>Heavy Equipment</p>
                            </div>
                          </li>
                          <li class="new-categories-item">
                            <div
                              class="new-categories-box"
                              onClick={(event) => this.redirectToSearch(event, "/listings/index.cfm/catid/1430")}
                            >
                              <div class="new-categories-image">
                                <img src={category9} loading="lazy" alt="Marine" />
                              </div>
                              <p>Marine</p>
                            </div>
                          </li>
                          <li class="new-categories-item">
                            <div
                              class="new-categories-box"
                              onClick={(event) => this.redirectToSearch(event, "/listings/index.cfm/catid/1008")}
                            >
                              <div class="new-categories-image">
                                <img src={category10} loading="lazy" alt="Metals" />
                              </div>
                              <p>Metals</p>
                            </div>
                          </li>
                          <li class="new-categories-item">
                            <div
                              class="new-categories-box"
                              onClick={(event) => this.redirectToSearch(event, "/listings/index.cfm/catid/1010")}
                            >
                              <div class="new-categories-image">
                                <img src={category11} loading="lazy" alt="Paper Pulp" />
                              </div>
                              <p>
                                Paper <br /> &amp; Pulp
                              </p>
                            </div>
                          </li>
                          <li class="new-categories-item">
                            <div
                              class="new-categories-box"
                              onClick={(event) => this.redirectToSearch(event, "/listings/index.cfm/catid/1395")}
                            >
                              <div class="new-categories-image">
                                <img src={category12} loading="lazy" alt="Solar" />
                              </div>
                              <p>Solar</p>
                            </div>
                          </li>
                          <li class="new-categories-item">
                            <div
                              class="new-categories-box"
                              onClick={(event) => this.redirectToSearch(event, "/listings/index.cfm/catid/1012")}
                            >
                              <div class="new-categories-image">
                                <img src={category13} loading="lazy" alt="Textiles" />
                              </div>
                              <p>Textiles</p>
                            </div>
                          </li>
                          <li class="new-categories-item">
                            <div
                              class="new-categories-box"
                              onClick={(event) => this.redirectToSearch(event, "/listings/index.cfm/catid/1013")}
                            >
                              <div class="new-categories-image">
                                <img src={category14} loading="lazy" alt="Transportation/ Vehicles/ Mobile Assets" />
                              </div>
                              <p>Transportation/ Vehicles/ Mobile Assets</p>
                            </div>
                          </li>
                          <li class="new-categories-item">
                            <div
                              class="new-categories-box"
                              onClick={(event) => this.redirectToSearch(event, "/listings/index.cfm/catid/1384")}
                            >
                              <div class="new-categories-image">
                                <img src={category15} loading="lazy" alt="Wind Energy" />
                              </div>
                              <p>Wind Energy</p>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                    {!this.state.loading && this.state.endingSoon?.length > 0 ? (
                      <div class="widget-box" key={"ending"}>
                        <div class="widget-header d-flex flex-wrap align-items-center justify-content-between add-custom-arrow position-relative">
                          <h4>Ending Soon</h4>
                          <>
                            <button
                              class="slick-prev slick-arrow slick-disabled arrow-slider"
                              aria-label="Previous"
                              type="button"
                              aria-disabled="true"
                              onClick={() => goPrev("ending")}
                            >
                              Previous
                            </button>

                            <button
                              class="slick-next slick-arrow arrow-slider"
                              aria-label="Next"
                              type="button"
                              aria-disabled="false"
                              onClick={() => goNext("ending")}
                            >
                              Next
                            </button>
                          </>
                        </div>
                        <div class="widget-body">
                          {this.state.endingSoon?.length > 4 ? (
                            <Slider
                              ref={(sliderInstance) => {
                                if (!sliderRefs.current) sliderRefs.current = [];
                                sliderRefs.current["ending"] = sliderInstance;
                              }}
                              {...productSlider}
                              className="card-list d-flex flex-wrap home-offshore-slider add-custom-arrow home-ending-soon-slider"
                            >
                              {this.state.endingSoon.map((item, index) => {
                                return (
                                  <div
                                    class="grid7-card-item w-100"
                                    onClick={() => navigate(`/listings/listing_detail.cfm/aucid/${item.auction_id}`)}
                                  >
                                    <div class="grid7-card-box w-100 h-100 d-flex flex-column align-items-start">
                                      <div class="grid7-card-img-box overflow-hidden">
                                        <img src={item.primary_picture} alt={item.title} />
                                      </div>
                                      <div class="grid7-card-content flex-grow-1 d-flex flex-column align-items-start w-100">
                                        <div class="grid7-card-title">{item.title}</div>
                                        <div class="grid7-card-subtitle">{item.cat_des}</div>
                                        {item?.asking_price > 0 ? (
                                          <div class="grid7-offer d-flex flex-column align-items-start">
                                            <div class="offer-label">Current Asking Price</div>
                                            <div class="offer-total">
                                              ${" "}
                                              {parseFloat(item.asking_price)
                                                .toFixed(2)
                                                .toString()
                                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                            </div>
                                            <div class="offer-badge">Buy Now or Counter Offer</div>
                                          </div>
                                        ) : (
                                          ""
                                        )}
                                        {item?.wholesale_value > 0 ? (
                                          <div class="grid7-highlighted-content w-100">
                                            <div class="g-h-label">Wholesale Value</div>
                                            <div class="g-h-total">
                                              <span>
                                                $
                                                {parseFloat(item.wholesale_value)
                                                  .toString()
                                                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                              </span>
                                            </div>
                                          </div>
                                        ) : (
                                          ""
                                        )}

                                        <div class="grid7-cans">
                                          {item.quantity} {item.unit}
                                        </div>
                                        <div class="grid7-location">{this.getLocation(item)}</div>
                                        {item.end_date ? (
                                          <div class="grid7-location">
                                            {" "}
                                            <DateFormat date={item.end_date} />
                                          </div>
                                        ) : (
                                          ""
                                        )}
                                        {item.bid_count > 0 ? (
                                          <div class="grid7-badge">
                                            {item.bid_count}{" "}
                                            {item.bid_count == "1" || item.bid_count == "0" ? "Bid" : "Bids"}
                                          </div>
                                        ) : (
                                          <div class="grid7-badge">0 Bid</div>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                );
                              })}
                            </Slider>
                          ) : (
                            <div className="card-list d-flex flex-wrap home-offshore-slider add-custom-arrow">
                              {this.state.endingSoon.map((item, index) => {
                                return (
                                  <div
                                    key={index}
                                    class="grid7-card-item "
                                    onClick={() => navigate(`/listings/listing_detail.cfm/aucid/${item.auction_id}`)}
                                  >
                                    <div class="grid7-card-box w-100 h-100 d-flex flex-column align-items-start">
                                      <div class="grid7-card-img-box overflow-hidden">
                                        <img src={item.primary_picture} alt={item.title} />
                                      </div>
                                      <div class="grid7-card-content flex-grow-1 d-flex flex-column align-items-start w-100">
                                        <div class="grid7-card-title">{item.title}</div>
                                        <div class="grid7-card-subtitle">{item.cat_des}</div>
                                        {item?.asking_price > 0 ? (
                                          <div class="grid7-offer d-flex flex-column align-items-start">
                                            <div class="offer-label">Current Asking Price</div>
                                            <div class="offer-total">
                                              ${" "}
                                              {parseFloat(item.asking_price)
                                                .toFixed(2)
                                                .toString()
                                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                            </div>
                                            <div class="offer-badge">Buy Now or Counter Offer</div>
                                          </div>
                                        ) : (
                                          ""
                                        )}
                                        {item?.wholesale_value > 0 ? (
                                          <div class="grid7-highlighted-content w-100">
                                            <div class="g-h-label">Wholesale Value</div>
                                            <div class="g-h-total">
                                              <span>
                                                $
                                                {parseFloat(item.wholesale_value)
                                                  .toString()
                                                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                              </span>
                                            </div>
                                          </div>
                                        ) : (
                                          ""
                                        )}

                                        <div class="grid7-cans">
                                          {item.quantity} {item.unit}
                                        </div>
                                        <div class="grid7-location">{this.getLocation(item)}</div>
                                        {item.end_date ? (
                                          <div class="grid7-location">
                                            {" "}
                                            <DateFormat date={item.end_date} />
                                          </div>
                                        ) : (
                                          ""
                                        )}
                                        {item.bid_count > 0 ? (
                                          <div class="grid7-badge">
                                            {item.bid_count}{" "}
                                            {item.bid_count == "1" || item.bid_count == "0" ? "Bid" : "Bids"}
                                          </div>
                                        ) : (
                                          <div class="grid7-badge">0 Bid</div>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          )}
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                    {allHomePage.edges.map((item, index) => (
                      <div class="widget-box" key={index}>
                        <div class="widget-header d-flex flex-wrap align-items-start justify-content-between add-custom-arrow position-relative">
                          <h4 style={{ maxWidth: "75%" }}>{item.node.category}</h4>
                          {item.node.category != "Featured" && (
                            <div className="d-none d-xl-block">
                              <a
                                href="javascript:void(0)"
                                className="link-butt-n-text"
                                onClick={(e) => {
                                  e.preventDefault();
                                  if (item.node.category == "Pipe") {
                                    navigate(`/pipe`);
                                  } else {
                                    navigate(`search/?categories.lvl0=${item.node.category}`);
                                  }
                                }}
                                style={{ marginRight: "60px" }}
                              >
                                View All
                              </a>
                            </div>
                          )}
                          <>
                            <button
                              class="slick-prev slick-arrow slick-disabled arrow-slider"
                              aria-label="Previous"
                              type="button"
                              aria-disabled="true"
                              onClick={() => goPrev(index)}
                            >
                              Previous
                            </button>

                            <button
                              class="slick-next slick-arrow arrow-slider"
                              aria-label="Next"
                              type="button"
                              aria-disabled="false"
                              onClick={() => goNext(index)}
                            >
                              Next
                            </button>
                          </>
                        </div>
                        <div class="widget-body">
                          <Slider
                            ref={(sliderInstance) => {
                              if (!sliderRefs.current) sliderRefs.current = [];
                              sliderRefs.current[index] = sliderInstance;
                            }}
                            {...productSlider}
                            className="card-list d-flex flex-wrap home-offshore-slider "
                          >
                            {item.node.auctions.map((item) => (
                              <div
                                class="grid7-card-item w-100"
                                onClick={() => navigate(`/listings/listing_detail.cfm/aucid/${item.auction_id}`)}
                              >
                                <div class="grid7-card-box w-100 h-100 d-flex flex-column align-items-start">
                                  {item?.primary_picture && (
                                    <div class="grid7-card-img-box overflow-hidden cursor-pointer">
                                      <img
                                        src={
                                          item.jpeg
                                            ? item.primary_picture.substring(0, 5) === "https"
                                              ? item.primary_picture + "_lp.jpeg"
                                              : process.env.GATSBY_MEDIA_URL + item.primary_picture + "_lp.jpeg"
                                            : item.primary_picture.substring(0, 5) === "https"
                                            ? item.primary_picture + "_lp.jpg"
                                            : process.env.GATSBY_MEDIA_URL + item.primary_picture + "_lp.jpg"
                                        }
                                        alt={item.title}
                                      />
                                    </div>
                                  )}
                                  <div class="grid7-card-content flex-grow-1 d-flex flex-column align-items-start w-100">
                                    <div class="grid7-card-title">
                                      {" "}
                                      <HTMLEllipsis unsafeHTML={item.title} maxLine="5" basedOn="letters" />
                                    </div>
                                    <div class="grid7-card-subtitle">{item.cat_des}</div>

                                    <div class="grid7-cans">
                                      {item.quantity} {item.unit}
                                    </div>
                                    <div class="grid7-location">{this.getLocation(item)}</div>
                                    {item.end_date ? (
                                      <div class="grid7-location">
                                        {" "}
                                        <DateFormat date={item.end_date} />
                                      </div>
                                    ) : (
                                      ""
                                    )}
                                    {item.bid_count > 0 ? (
                                      <div class="grid7-badge">
                                        {item.bid_count}{" "}
                                        {item.bid_count == "1" || item.bid_count == "0" ? "Bid" : "Bids"}
                                      </div>
                                    ) : (
                                      <div class="grid7-badge">0 Bid</div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            ))}
                          </Slider>
                        </div>
                        {item?.node?.category !== "Featured" && (
                          <div className="mt-2 d-xl-none">
                            <a
                              href="javascript:void(0)"
                              class={`btn btn-brand-color2 text-uppercase view-all-home `}
                              onClick={(e) => {
                                e.preventDefault();
                                if (item.node.category == "Pipe") {
                                  navigate(`/pipe`);
                                } else {
                                  navigate(`search/?categories.lvl0=${item.node.category}`);
                                }
                              }}
                            >
                              View All
                            </a>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* <div class="mob-filter-btn-group  has-shadow d-lg-none d-flex align-items-center">
            <a
              href="javascript:void(0)"
              class="filter-btn d-flex align-items-center justify-content-center"
              data-bs-toggle="modal"
              data-bs-target="#browseCollapse"
              onClick={this.toggleMobileFilter}
            >
              <p>Browse</p>
            </a>
            {typeof window !== "undefined" && window.localStorage.getItem("token") ? (
              <Link to="/members/post-listing" class="post-listing d-flex align-items-center justify-content-center">
                + Post a Listing
              </Link>
            ) : (
              <a
                onClick={(e) => {
                  e.preventDefault();
                  typeof window !== "undefined" && localStorage.setItem("redirect", "/members/post-listing");
                  navigate("/members/login");
                }}
                href="javascript:void(0)"
                class="post-listing d-flex align-items-center justify-content-center"
              >
                + Post a Listing
              </a>
            )}
          </div> */}

          <Footer />
        </div>
      </>
    );
  }
}

export default HomePage;
export const Head = ({ location }) => (
  <SEO
    title={`Global Marketplace for Asset Recovery and Surplus Inventory | Salvex`}
    description={`Salvex is a global auction platform that handles the sale of surplus, salvage, scrap, damaged, bankrupt inventories for asset recovery, insurance, transportation, manufacturing, oil and gas industries.`}
    canonical={`https://www.salvex.com/`}
  />
);
